import component from './AppHeaderFooter.container';

export default component;
